import store from '@/store';
import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { instanciaAxios } from '@/services/base.service';
import { AxiosError, AxiosResponse } from 'axios';
import { MonitoramentoInterface } from '@/shared/models/monitoramento/monitoramento.interface';
import Format from '@/shared/utils/format.util';
import queryUtil from '@/shared/utils/query.util';
import { EquipamentoFilter } from '@/shared/models/equipamento/equipamento.filter';

const monitoramento = 'monitoramento';

export default class MonitoramentoService {
  async buscarPorFiltro(filtro: EquipamentoFilter): Promise<MonitoramentoInterface[] | null> {
    const filtroPesquisa = { ...filtro };
    if (filtroPesquisa.cnpjPontoDeVenda !== undefined && filtroPesquisa.cnpjPontoDeVenda !== null) {
      filtroPesquisa.cnpjPontoDeVenda = Format.semPontoTracoBarra(filtroPesquisa.cnpjPontoDeVenda);
    }
    const query = queryUtil.getQuery(filtroPesquisa);
    return await instanciaAxios.get(`${monitoramento}${query}`)
      .then((response: AxiosResponse<MonitoramentoInterface[]>) => response.data)
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        console.error(error);
        return null;
      });
  }
}
